import { Fragment } from 'react'
import { Link } from 'react-router-dom'
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb'
import { getHrefWithThreadPreservation } from '@/utils/thread-navigation'
import { cn } from '@/lib/utils'

export type PageBreadcrumbItem = {
  label: string
  /** Omit on the current page segment (renders as non-link). */
  to?: string
}

export interface PageBreadcrumbsProps {
  items: PageBreadcrumbItem[]
  className?: string
}

export function PageBreadcrumbs({ items, className }: PageBreadcrumbsProps) {
  if (items.length === 0) return null

  return (
    <Breadcrumb className={cn('w-full min-w-0', className)}>
      <BreadcrumbList>
        {items.map((item, index) => {
          const isLast = index === items.length - 1
          const key = `${item.to ?? ''}-${item.label}-${index}`

          return (
            <Fragment key={key}>
              <BreadcrumbItem>
                {item.to && !isLast ? (
                  <BreadcrumbLink asChild>
                    <Link to={getHrefWithThreadPreservation(item.to)}>{item.label}</Link>
                  </BreadcrumbLink>
                ) : (
                  <BreadcrumbPage>{item.label}</BreadcrumbPage>
                )}
              </BreadcrumbItem>
              {!isLast ? <BreadcrumbSeparator /> : null}
            </Fragment>
          )
        })}
      </BreadcrumbList>
    </Breadcrumb>
  )
}
